export enum RESOLUTION {
  QUARTER_HOURLY = "QUARTER_HOURLY",
  HOURLY = "HOURLY",
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  MONTHELY = "MONTHELY",
  YEARLY = "YEARLY",
}
